/** @namespace ShopifyCheckout/Api/Checkout/Processor/processCheckout */
export const processCheckout = () => {};
